import script from "./ButtonPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonPage.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./ButtonPage.vue?vue&type=style&index=0&id=7c3851fb&module=styles&lang=css"
cssModules["styles"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__